module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/304.e6de2ce1.png";